@if (visible) {
  <div class="wiki-attention-backdrop" (click)="dismissForSession()">
    <div class="wiki-attention-modal" (click)="$event.stopPropagation()">
      <div class="wiki-attention-header">
        <div class="wiki-attention-brand">
          <div class="wiki-attention-icon">
            <span class="pi pi-book"></span>
          </div>
          <div>
            <h2>Setup guides &amp; tutorials live in the Wiki</h2>
            <p>
              Use the in-app documentation for step-by-step setup and module tutorials.
              Open it anytime from the <strong>?</strong> button in the top bar.
            </p>
          </div>
        </div>
        <button type="button" class="wiki-attention-close" (click)="dismissForSession()" aria-label="Close">
          <span class="pi pi-times"></span>
        </button>
      </div>

      <div class="wiki-attention-body">
        <div class="wiki-attention-section">
          <p class="wiki-attention-section-title">Setup Guide</p>
          <div class="wiki-attention-grid">
            @for (topic of setupTopics; track topic.id) {
              <button type="button" class="wiki-attention-card" (click)="openWikiTopic(topic.id)">
                <span class="pi" [ngClass]="topic.icon"></span>
                <div>
                  <p class="wiki-attention-card-title">{{ topic.title }}</p>
                  <p class="wiki-attention-card-desc">{{ topic.description }}</p>
                </div>
                <span class="pi pi-arrow-right wiki-attention-card-arrow"></span>
              </button>
            }
          </div>
        </div>

        <div class="wiki-attention-section">
          <p class="wiki-attention-section-title">Tutorials</p>
          <div class="wiki-attention-grid">
            @for (topic of tutorialTopics; track topic.id) {
              <button type="button" class="wiki-attention-card" (click)="openWikiTopic(topic.id)">
                <span class="pi" [ngClass]="topic.icon"></span>
                <div>
                  <p class="wiki-attention-card-title">{{ topic.title }}</p>
                  <p class="wiki-attention-card-desc">{{ topic.description }}</p>
                </div>
                <span class="pi pi-arrow-right wiki-attention-card-arrow"></span>
              </button>
            }
          </div>
        </div>
      </div>

      <div class="wiki-attention-footer">
        <button type="button" class="wiki-attention-btn wiki-attention-btn-ghost" (click)="dontShowAgain()">
          Don't show again
        </button>
        <button type="button" class="wiki-attention-btn wiki-attention-btn-secondary" (click)="dismissForSession()">
          Maybe later
        </button>
        <button type="button" class="wiki-attention-btn wiki-attention-btn-primary" (click)="openTutorials()">
          Browse tutorials
        </button>
      </div>
    </div>
  </div>
}
